import { Drawer, Loading } from "@components";
import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import { useEffect, useState } from "react";
import { Titles } from "../../variables/Titles";
import FixedValueForm from "../types/FixedValueForm";

export const OrderBrandForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState([]);

  const loadBrands = async () => {
    setLoading(true);
    const response = await OlgaEnvironmentsAPI.getBrands();
    const list = response.getData([]);
    setBrands(list.map((b) => ({ label: b.name, value: b.id })));
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      loadBrands();
    }
  }, [visible]);

  const loading_style = {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderBrand}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      {loading ? (
        <div style={loading_style}>
          <Loading />
        </div>
      ) : (
        <FixedValueForm
          node={node}
          options={brands}
          onSave={(node) => onSave(node)}
          onRemove={onRemove}
        />
      )}
    </Drawer>
  );
};
